import { animate, createTimeline, stagger } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, SPRING_PRESETS, resolveDuration, resolveStagger, BLUR } from '../motion-tokens.js';
import { createDrawable } from '../../vendor/anime.esm.js';

export const featuresV1 = (el) => {
    const cards = el.querySelectorAll('.feature-card, .card');
    const icons = el.querySelectorAll('.block-icon-svg svg, .feature-icon svg');
    const tl = createTimeline({ defaults: { ease: EASE.snappy }, });

    cards.forEach(c => { c.style.opacity = '0'; c.style.transform = 'translateY(40px)'; c.style.filter = BLUR.normal; });

    if (cards.length) tl.add(cards, {
        opacity:    [0, 1],
        translateY: [40, 0],
        scale:      (el, i, total) => {
            const centerDist = Math.abs(i - (total - 1) / 2);
            const normalizedDist = centerDist / (total / 2 || 1);
            return [0.88 + (0.12 * (1 - normalizedDist)), 1];
        },
        filter:     [BLUR.normal, BLUR.none],
        delay:      stagger(resolveStagger(STAGGER.normal), { from: 'center', start: 150 }),
        duration:   resolveDuration(DURATION.normal),
        ease:       SPRING_PRESETS.deluxe,
    });

    icons.forEach((svg) => {
        const primitives = svg.querySelectorAll('path, line, polyline, circle, rect');
        primitives.forEach((prim, i) => {
            try {
                const drawable = createDrawable(prim);
                if (drawable) {
                    animate(drawable, {
                        draw:     ['0 0', '0 1'],
                        duration: resolveDuration(DURATION.normal),
                        delay:    i * 60,
                        ease:     EASE.refined,
                    });
                }
            } catch(e) { /* skip */ }
        });
    });

    return tl;
};

export const featuresV2 = (el) => {
    const rows = el.querySelectorAll('.feature-row, .feature-item, li');
    const bars = el.querySelectorAll('.feature-bar, .accent-bar, [class*="bar"]');

    rows.forEach(r => { r.style.opacity = '0'; r.style.transform = 'translateX(-40px)'; r.style.filter = 'blur(3px)'; });
    bars.forEach(b => { b.style.opacity = '0'; b.style.transform = 'scaleX(0)'; b.style.transformOrigin = 'left center'; });

    const tl = createTimeline({ defaults: { ease: EASE.snappy }, });

    if (rows.length) tl.add(rows, {
        opacity:    [0, 1],
        translateX: [-40, 0],
        filter:     [BLUR.light, BLUR.none],
        delay:      stagger(resolveStagger(60)),
        duration:   resolveDuration(DURATION.normal),
    });

    if (bars.length) tl.add(bars, {
        scaleX:          [0, 1],
        opacity:         [0, 1],
        delay:           stagger(resolveStagger(60)),
        duration:        resolveDuration(DURATION.fast),
        transformOrigin: 'left center',
    }, '-=400');

    return tl;
};

export const featuresV3 = (el) => {
    const icons  = el.querySelectorAll('.feature-card .block-icon-svg, .feature-card .block-icon, .feature-card .feature-icon');
    const texts  = el.querySelectorAll('.feature-card h3, .feature-card p, .feature-title, .feature-desc');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    if (icons.length) tl.add(icons, {
        rotateY: [90, 0],
        scale:   [0.8, 1],
        opacity: [0, 1],
        delay:   stagger(resolveStagger(STAGGER.fast)),
        duration: resolveDuration(DURATION.normal),
        ease:    SPRING_PRESETS.magnetic,
    });

    if (texts.length) tl.add(texts, {
        opacity:    [0, 1],
        translateY: [15, 0],
        filter:     ['blur(2px)', 'blur(0px)'],
        delay:      stagger(resolveStagger(STAGGER.fast)),
        duration:   resolveDuration(DURATION.normal),
        ease:       SPRING_PRESETS.deluxe,
    }, '-=300');

    return tl;
};
